import { render, staticRenderFns } from "./CardViewerComponent.vue?vue&type=template&id=9bfdb352"
import script from "./CardViewerComponent.vue?vue&type=script&lang=js"
export * from "./CardViewerComponent.vue?vue&type=script&lang=js"
import style0 from "./CardViewerComponent.vue?vue&type=style&index=0&id=9bfdb352&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports